import React, { useState, useEffect } from "react";
import { IoSearch } from "react-icons/io5";
import { notifyError } from "../utils/toast";

const ListModel = ({
  open,
  onClose,
  onSubmit,
  data = [],
  selectedId,
  meetingId,
  setSelectedId,
  isResign = false,
}) => {
  const [filterList, setFilterList] = useState(data);
  const [search, setSearch] = useState("");
  const [previousSelectedPerson , setPreviousSelectedPerson ] = useState(selectedId);

  console.log(" selectedId", selectedId);
  console.log("previousSelectedPerson", previousSelectedPerson);

  useEffect(() => {
    setFilterList(data);
  
       if (open) {
      setPreviousSelectedPerson(selectedId);
    }
  }, [data, open]);
  

  const handleChange = (event) => {
    const searchValue = event.target.value || "";
    setSearch(searchValue);

    if (!searchValue) {
      setFilterList(data);
      return;
    }

    const filteredData = data.filter((list) =>
      list?.name?.toLowerCase().includes(searchValue.toLowerCase())
    );

    setFilterList(filteredData);
  };

  const handleSubmit = () => {
   
    if(selectedId === previousSelectedPerson){
      notifyError("You have already selected this person.");
      return;
    }else{
      if (selectedId) {
        onSubmit(meetingId, selectedId , previousSelectedPerson );
      }
    }
     
   
  };

const handleClose = () => { 
  setSearch("");
  onClose();
}

  const handleSelectedPerson = (id) => {
   
    setSelectedId(id);
  };

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-30 p-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="bulk-upload-title"
    >
      <div className="bg-white rounded-[10px] shadow-xl w-[500px] p-6 transform transition-all">
        {/* Header */}
        <div className="flex bg-slate-100 p-2 rounded-md justify-between items-center mb-6">
          <h2
            id="bulk-upload-title"
            className="text-lg font-medium text-green-700"
          >
            Meeting Person
          </h2>
          <button
            onClick={handleClose}
            className="text-red-600 bg-white px-2 focus:outline-none rounded-full p-1"
            aria-label="Close modal"
          >
            <svg
              className="w-5 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        {/* Search Input */}
        <div className="relative mb-4">
          <IoSearch className="absolute top-2 left-2 text-xl text-gray-500" />
          <input
            type="text"
            value={search}
            onChange={handleChange}
            placeholder="Enter Search"
            className="w-full pl-8 p-1 border rounded-full border-gray-400 focus:outline-none focus:ring-2 focus:ring-green-500"
          />
        </div>

        <div className="px-2 py-4 overflow-y-auto h-72  rounded-md">
          {filterList.length > 0 ? (
            filterList.map((item) => (
              <div key={item.id} className="flex items-center gap-3 mb-3">
                <input
                  type="radio"
                  name="model"
                  id={`radio-${item.id}`}
                  value={item.id}
                  checked={selectedId === item.id}
                  className="accent-green-600 h-4 w-4 cursor-pointer"
                  onChange={() => handleSelectedPerson(item.id)}
                />
                <label
                  htmlFor={`radio-${item.id}`}
                  className="text-gray-600 text-[14px] cursor-pointer"
                >
                  {item.name}
                </label>
              </div>
            ))
          ) : (
            <p className="text-gray-500 text-sm text-center">
              No matching results.
            </p>
          )}
        </div>

        <div
          onClick={handleSubmit}
          className={`mt-7 text-white text-center py-2 px-2 rounded-[10px] cursor-pointer ${
            selectedId ? "bg-primary" : "bg-gray-400 cursor-not-allowed"
          }`}
        >
          {isResign ? "Assign a PA" : "Change Assignee"} 
        </div>
      </div>
    </div>
  );
};

export default ListModel;
